import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const loginApi = async (data) =>
    Promise.resolve(axios.post(endpoints.logIn, data));
